// Progress bar utility functions

export function calculateProgress(available: number, total: number): number {
  if (total === 0) return 0;
  // 残り割合を計算 (100% = 全て残ってる, 0% = 完売)
  return Math.round((available / total) * 100);
}

export function getProgressColor(percentage: number, available: number): string {
  if (available === 0) return 'bg-gray-400';     // 完売: グレー
  if (percentage <= 20) return 'bg-red-500';     // 0-20%: 赤 (残り少ない)
  if (percentage <= 40) return 'bg-orange-500';  // 21-40%: オレンジ
  if (percentage <= 60) return 'bg-yellow-500';  // 41-60%: 黄色
  if (percentage <= 80) return 'bg-green-500';   // 61-80%: 緑
  return 'bg-green-500';                         // 81-100%: 緑 (開始直後)
}

export function getProgressLabel(available: number, total: number): string {
  const percentage = calculateProgress(available, total);

  if (available === 0) return '受付終了';
  if (percentage <= 20) return '残りわずか！';
  if (percentage <= 40) return '人気沸騰中';
  if (percentage <= 60) return '好評開催中';
  if (percentage <= 80) return '参加受付中';
  return '開催中';
}

export function isSoldOut(available: number): boolean {
  return available === 0;
}